import * as o from "react";
import { c as r } from "../createReactComponent-58f9bea8.mjs";
import { P as m, r as t } from "../pill-group-834f5519.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
import "../pill-a1831740.mjs";
import "../state-7560d4dc.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../icon-button-a9d2a2d1.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../button-7600b6ca.mjs";
import "../utils-cf5bbdd1.mjs";
const v = r({ tagName: "ex-pill-group", elementClass: m, react: o, events: { onClear: "onClear", onRemove: "onRemove" }, displayName: "ExPillGroup", registerWebComponent: t });
export {
  v as ExPillGroup,
  t as register
};
